import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { NbButtonModule, NbLayoutModule, NbThemeModule, NbAlertModule, NbIconModule } from '@nebular/theme';

@NgModule({
  declarations: [
    LoginComponent,
  ],
  imports: [
    CommonModule,
    NbLayoutModule,
    NbThemeModule,
    NbButtonModule,
    NbAlertModule,
    NbIconModule,
  ],
})
export class LoginModule {

}
